import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { ErrorMessage, SelectDropdown } from '@gsa/afp-component-library';

const YearInput = ({
  name,
  isAddForm,
  years,
  isRequired = false,
  selectedYear = null,
  disabled = false,
}) => {
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (isAddForm) {
      const nextYear = new Date().getFullYear() + 1;
      setValue(name, selectedYear || nextYear.toString());
    }
  }, [isAddForm, setValue, name, selectedYear]);

  return (
    <>
      <h2 className="font-sans-xs" aria-label="Contract year">
        Contract year{' '}
        {isRequired && <span className="usa-hint usa-hint--required">*</span>}
      </h2>
      {isAddForm && (
        <Controller
          name={name}
          control={control}
          rules={{ required: isRequired ? 'This field is required' : false }}
          render={({ field }) => (
            <SelectDropdown
              data-testid={`${name}-select`}
              aria-label="Contract year"
              aria-required={isRequired ? 'true' : 'false'}
              options={years}
              onChange={field.onChange}
              onBlur={field.onBlur}
              value={selectedYear || field.value}
              ref={field.ref}
              disabled={disabled}
            />
          )}
        />
      )}
      {!isAddForm && (
        <span className="text-normal">{selectedYear || watch(name)}</span>
      )}
      {errors[name]?.message && (
        <ErrorMessage>{errors[name].message}</ErrorMessage>
      )}
    </>
  );
};

YearInput.propTypes = {
  name: PropTypes.string.isRequired,
  isAddForm: PropTypes.bool.isRequired,
  years: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  isRequired: PropTypes.bool,
  selectedYear: PropTypes.string,
  disabled: PropTypes.bool,
};

export default YearInput;
